var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvatars = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4EB6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C10.6962 10 11.3639 9.72344 11.8562 9.23116C12.3484 8.73887 12.625 8.07119 12.625 7.375C12.625 6.67881 12.3484 6.01113 11.8562 5.51884C11.3639 5.02656 10.6962 4.75 10 4.75C9.30381 4.75 8.63613 5.02656 8.14385 5.51884C7.65156 6.01113 7.375 6.67881 7.375 7.375C7.375 8.07119 7.65156 8.73887 8.14385 9.23116C8.63613 9.72344 9.30381 10 10 10ZM11.75 7.375C11.75 7.83913 11.5656 8.28425 11.2374 8.61244C10.9092 8.94063 10.4641 9.125 10 9.125C9.53587 9.125 9.09075 8.94063 8.76256 8.61244C8.43438 8.28425 8.25 7.83913 8.25 7.375C8.25 6.91087 8.43438 6.46575 8.76256 6.13756C9.09075 5.80937 9.53587 5.625 10 5.625C10.4641 5.625 10.9092 5.80937 11.2374 6.13756C11.5656 6.46575 11.75 6.91087 11.75 7.375ZM15.25 14.375C15.25 15.25 14.375 15.25 14.375 15.25H5.625C5.625 15.25 4.75 15.25 4.75 14.375C4.75 13.5 5.625 10.875 10 10.875C14.375 10.875 15.25 13.5 15.25 14.375ZM14.375 14.3715C14.3741 14.1562 14.2403 13.5087 13.647 12.9155C13.0765 12.345 12.0029 11.75 10 11.75C7.99625 11.75 6.9235 12.345 6.353 12.9155C5.75975 13.5087 5.62675 14.1562 5.625 14.3715H14.375Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvatars);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/avatars.a2fae712504f8bd1aec8244e419063af.svg";